import { render, staticRenderFns } from "./persistentvolumeclaim.vue?vue&type=template&id=8908989c&"
import script from "./persistentvolumeclaim.vue?vue&type=script&lang=js&"
export * from "./persistentvolumeclaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports